/*=========================================================================================
  File Name: moduleRolesMutations.js
  Description: Roles Module Mutations
==========================================================================================*/
import _ from "lodash";
export default {
	SET_ROLES(state, roles) {
		state.roles = roles;
	},
	SET_ROLE_CATEGORY_SIDEBAR_STATUS(state, value) {
		state.showRolesCategorySidebar = value;
	},
	ADD_NEW_ROLE(state, role) {
		state.roles.unshift(role);
	},
	UPDATE_ROLE(state, role) {
		const idx = _.findIndex(state.roles, { id: role.id });
		if (idx !== -1) {
			Object.assign(state.roles[idx], role);
		}
	},
	DELETE_ROLE(state, role) {
		const idx = _.findIndex(state.roles, { id: role.id });
		if (idx !== -1) {
			state.roles.splice(idx, 1);
		}
	},
	SET_TOTAL_ROLES(state, total) {
		state.total = total;
	},
	SET_MODULE_ROLES(state, moduleRoles) {
		state.moduleRoles = moduleRoles;
	}
};
